// Cart pair-pool behaviors (page-07 §③): show one suggestion at a time,
// ‹ › cycle with an "n of N" counter, × dismiss remembered in sessionStorage
// for the session. ADD buttons are native product forms - Horizon's own
// submit handler updates the cart and morphs the drawer, and the re-render
// drops added companions from the pool server-side, so no cart logic here.
class SkullettePairPool extends HTMLElement {
  static DISMISS_KEY = 'sk-pair-pool-dismissed';
  // Morph updates data-count without re-running connectedCallback; re-render
  // so the index clamps and the ‹ › nav hides when the pool drops to one.
  // Deferred: the attribute flips BEFORE morph patches the children, so a
  // synchronous render here would be overwritten by the rest of the morph.
  static observedAttributes = ['data-count'];

  attributeChangedCallback() {
    if (this.index) queueMicrotask(() => this.render());
  }

  connectedCallback() {
    if (sessionStorage.getItem(SkullettePairPool.DISMISS_KEY)) {
      this.remove();
      return;
    }
    this.index = 1;
    this.querySelector('[ref-pool-prev]')?.addEventListener('click', () => this.cycle(-1));
    this.querySelector('[ref-pool-next]')?.addEventListener('click', () => this.cycle(1));
    this.querySelector('[ref-pool-dismiss]')?.addEventListener('click', () => {
      sessionStorage.setItem(SkullettePairPool.DISMISS_KEY, '1');
      this.remove();
    });
    this.render();
  }

  // Morph updates data-count on the persistent element without re-running
  // connectedCallback - always read it fresh (reviewer H2).
  get count() {
    return parseInt(this.dataset.count, 10) || 1;
  }

  cycle(dir) {
    this.index = ((this.index - 1 + dir + this.count) % this.count) + 1;
    this.render();
  }

  render() {
    const count = this.count;
    if (this.index > count) this.index = 1;
    for (const card of this.querySelectorAll('[data-pool-index]')) {
      card.hidden = parseInt(card.dataset.poolIndex, 10) !== this.index;
    }
    const counter = this.querySelector('[ref-pool-counter]');
    if (counter) counter.textContent = `${this.index} of ${count}`;
    const solo = count < 2;
    this.querySelector('[ref-pool-prev]')?.toggleAttribute('hidden', solo);
    this.querySelector('[ref-pool-next]')?.toggleAttribute('hidden', solo);
    counter?.toggleAttribute('hidden', solo);
  }
}

if (!customElements.get('skullette-pair-pool')) {
  customElements.define('skullette-pair-pool', SkullettePairPool);
}
